<template lang="pug">
    div#popup
        div.popup__wrap(:class="{'is-show': toggle}")
            form.popupAddWord(:class="{'is-show': toggle}" @submit.prevent="onSubmit()")
                div.titleBlock Добавление слов
                div.icon-close(@click="onClose")
                    include ../snippets/close.pug

                div.msg__success.is-active(v-if="success" v-html="success")
                div.msg__error.is-active(v-if="errors" v-html="errors")
                div.formGroup.send
                    label.label
                        div.name Добавить слово на русском
                        input.input(type='text', v-model="word.ru ")
                    span.msg
                div.formGroup.send
                    label.label
                        div.name Добавить слово на английском
                        input.input(type='text', v-model="word.en ")
                    span.msg
                div.formGroup.send
                    label.label
                        div.name Добавить слово на иврите
                        input.input(type='text', v-model="word.he ")
                    span.msg
                div.formGroup.send
                    label.label
                        div.name Добавить слово на джуури (латинице) *
                        input.input(type='text', v-model="word.lat")
                    span.msg
                div.formGroup.send
                    label.label
                        div.name Добавить слово на джуури (кириллице) *
                        input.input(type='text', v-model="word.cir")
                    span.msg
                button.btn.btn-green.btn-large.btnSendWord(type='submit') Добавить
        //popup__wrap
    //popup
</template>

<script>
    import NewWordsService from '@/services/NewWords';

    export default {
        name: "add-word-popup",
        template: '#popup',
        props: {
            toggle: {
                type: Boolean,
                required: true
            },
        },
        data() {
            return {
                word: {
                    ru: '',
                    en: '',
                    he: '',
                    cir: '',
                    lat: '',
                    status: 0,
                    playlist: 0,
                },
                success: null,
                errors: null,
                toggleLocal: this.toggle
            }
        },
        methods: {
            onClose() {
                this.$emit('close', this.toggleLocal, 'addWord');
            },
            async onSubmit() {
                if ((this.word.ru || this.word.en || this.word.he) && (this.word.cir && this.word.lat)) {
                    await NewWordsService.create(this.word);
                    this.errors = '';
                    this.word.ru = '';
                    this.word.en = '';
                    this.word.he = '';
                    this.word.cir = '';
                    this.word.lat = '';
                    this.success = 'Вы успешно добавили слово!';
                    setTimeout(() => {
                        this.success = null;
                    }, 2000);
                } else {
                    this.errors = '* Заполните обязательные поля!';
                }
            }
        }
    }
</script>
